/**
 * Feature flags for controlling feature availability
 *
 * Usage:
 * ```typescript
 * import { featureFlags } from '@/utils/featureFlags';
 *
 * if (featureFlags.stateSelector) {
 *   // Show state selector UI
 * }
 * ```
 *
 * Environment variables:
 * - VITE_FEATURE_STATE_SELECTOR: Enable multi-state selector UI (default: false)
 */
export const featureFlags = {
  /** Enable state selector in navigation components */
  stateSelector: import.meta.env.VITE_FEATURE_STATE_SELECTOR === 'true',
  /** Enable session year selector in navigation components */
  sessionYearSelector: import.meta.env.VITE_FEATURE_SESSION_YEAR_SELECTOR === 'true',
  /** Enable campaign finance tool in navigation */
  campaignFinance: import.meta.env.VITE_FEATURE_CAMPAIGN_FINANCE === 'true',

  /** Enable connected apps (OAuth) in account settings */
  connectedApps: import.meta.env.VITE_FEATURE_CONNECTED_APPS === 'true',
} as const;
